import createDebug from "debug";

const debug = createDebug("APP");

export const createLogger = (namespace: string) => ({
  debug: debug.extend("DEBUG", ":").extend(namespace), // shows in development
  info: debug.extend("INFO", ":").extend(namespace), // shows in production
  error: debug.extend("ERROR", ":").extend(namespace) // shows in production
});